const mediaItems = [
  {
    title: '某知名女星深夜密会神秘男子全程实拍',
    duration: '15:42',
    image: 'https://readdy.ai/api/search-image?query=Dark%20blurry%20night%20street%20scene%20with%20paparazzi%20style%2C%20two%20figures%20walking%20in%20shadows%2C%20coral%20orange%20street%20lamp%20glow%2C%20surveillance%20footage%20aesthetic%2C%20mysterious%20noir%20cinematography%2C%20high%20contrast%2C%20grainy%20texture&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '行业内幕：直播带货假数据产业链暗访',
    duration: '22:08',
    image: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20multiple%20computer%20screens%20showing%20data%20dashboards%2C%20hidden%20camera%20angle%2C%20coral%20orange%20screen%20glow%2C%20investigative%20documentary%20aesthetic%2C%20cinematic%20lighting%2C%20suspenseful%20high%20contrast&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '饭圈塌房实录：顶流男团成员私下真实面目',
    duration: '18:35',
    image: 'https://readdy.ai/api/search-image?query=Stage%20backstage%20area%20with%20dramatic%20shadows%2C%20anonymous%20figure%20in%20spotlight%2C%20entertainment%20industry%20expose%20theme%2C%20coral%20orange%20accent%20lighting%2C%20documentary%20cinematography%2C%20moody%20noir%20atmosphere%2C%20high%20contrast&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '社会事件深度解析：被掩盖三个月的真相',
    duration: '28:51',
    image: 'https://readdy.ai/api/search-image?query=Investigation%20room%20with%20evidence%20board%20covered%20in%20photos%20and%20notes%2C%20dark%20ambient%20lighting%2C%20coral%20orange%20accent%20light%2C%20true%20crime%20documentary%20aesthetic%2C%20cinematic%20high%20contrast%2C%20suspenseful%20noir%20style&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950">吃瓜视频</h2>
            <p className="text-foreground-500 text-sm mt-1">独家暗访与深度追踪实拍</p>
          </div>
          <span className="text-foreground-400 text-sm hidden md:block">每日更新 · 一手素材</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group relative rounded-2xl overflow-hidden bg-background-200 aspect-[4/3] block"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-black/50 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent-500/80 transition-colors">
                  <i className="ri-play-fill text-white text-xl md:text-2xl ml-0.5"></i>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4 bg-gradient-to-t from-black/80 to-transparent pt-10">
                <h3 className="text-white font-semibold text-sm md:text-base leading-tight line-clamp-2">{item.title}</h3>
                <span className="text-white/50 text-xs mt-1 inline-block">{item.duration}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}